import {
    Button,
    Container,
    Grid,
    makeStyles,
    Paper,
    Typography
} from "@material-ui/core"
import React from "react"
import Theme from "../../commons/Theme"
import logo from "../../assets/logo.jpeg"
import { useHistory } from "react-router-dom"
import ProviderRegisterContact from "./ProviderRegisterContact"
import ProviderRegisterCompanyInfo from "./ProviderRegisterCompanyInfo"
import ProviderRegisterPassword from "./ProviderRegisterPassword"
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import LoadPage from "../../components/LoadPage"
import PlatformRequest from "../../utils/PlatformRequest"


const useStyles = makeStyles((theme) => ({
    boxRegister: {
        padding: 40,
    },
    logo: {
        marginTop: 30,
        marginBottom: 30
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        height: 40
    },
    iconSuccess: {
        color: "rgb(46, 139, 5)",
        fontSize: 120
    }
}))

const ProviderRegisterPage = () => {
    const classes = useStyles()
    const history = useHistory()

    const flow = [
        { step: 0, nextStepDescription: "Informar o Contato" },
        { step: 1, nextStepDescription: "Informar dados para acesso" },
        { step: 2, nextStepDescription: "Criar Cadastro" },
        { step: 3, nextStepDescription: "Acessar" }
    ]
    const [load, setLoad] = React.useState(false)
    const [actualStep, setActualStep] = React.useState(flow[0])
    const [required, setRequired] = React.useState({
        ssn: false,
        companyName: false,
        fancyName: false,
        carType: false,
        nationality: false,
        part: false,
        brand: false,
        segment: false,
        password: false
    })
    const [ssnValid, setSsnValid] = React.useState(true)
    const [provider, setProvider] = React.useState({
        ssn: "",
        fancyName: "",
        phone: "",
        email: "",
        companyName: "",
        contactTypeList: [],
        nationalityList: [],
        carTypeList: [],
        carPartList: [],
        carBrandList: [],
        segmentList: [],
        password: "",
        confirmPassword: ""
    })
    const validateCompany = () => {
        if (provider.ssn === "" || provider.ssn === undefined || !ssnValid) {
            setRequired({ ...required, ssn: true })
            return false
        }

        if (provider.companyName === "" || provider.companyName === undefined) {
            setRequired({ ...required, companyName: true })
            return false
        }

        if (provider.fancyName === "" || provider.fancyName === undefined) {
            setRequired({ ...required, fancyName: true })
            return false
        }

        if (provider.carTypeList.length === 0) {
            setRequired({ ...required, carType: true })
            return false
        }

        if (provider.nationalityList.length === 0) {
            setRequired({ ...required, nationality: true })
            return false
        }

        if (provider.carPartList.length === 0) {
            setRequired({ ...required, part: true })
            return false
        }

        if (provider.segmentList.length === 0) {
            setRequired({ ...required, segment: true })
            return false
        }

        if (provider.carBrandList.length === 0) {
            setRequired({ ...required, brand: true })
            return false
        }

        return true
    }

    const validatePassword = () => {
        if (provider.password === "" || provider.confirmPassword === "") {
            return false
        }

        if (provider.password === provider.confirmPassword) {
            return true
        }

        return false
    }

    const createRegister = async () => {

        if (actualStep.step === 0) {
            if (!validateCompany()) {
                return
            }
        }

        if (actualStep.step === 1) {
            if (provider.contactTypeList.length === 0) {
                setRequired({ ...required, contact: true })
                return
            }
        }

        if (actualStep.step === 2) {
            if (!validatePassword()) {
                setRequired({ ...required, password: true })
                return
            }

            await createProvider().then(() => {
                setLoad(false)
                return
            }).catch(() => {
                setLoad(false)
                return
            })
        }

        if (actualStep.step === 3) {
            history.push("/")
        }

        const nextStep = actualStep.step + 1
        setActualStep(flow.filter((value) => value.step === nextStep)[0])
    }

    const buttonBack = () => {
        const nextStep = actualStep.step - 1

        if (nextStep < 0) {
            return history.push("/")
        }

        setActualStep(flow.filter((value) => value.step === nextStep)[0])
    }

    const createProvider = async () => {
        const payload = {
            ssn: provider.ssn.replace(/[^\d]+/g, ''),
            fancyName: provider.fancyName,
            phone: provider.phone.replace(/[^\d]+/g, ''),
            email: provider.email,
            companyName: provider.companyName,
            contactTypeList: provider.contactTypeList,
            nationalityList: provider.nationalityList,
            carTypeList: provider.carTypeList,
            carPartList: provider.carPartList,
            carBrandList: provider.carBrandList.map((item) => item.id),
            segmentList: provider.segmentList.map((item) => item.id),
            password: provider.password,
            confirmPassword: provider.confirmPassword
        }

        setLoad(true)
        return PlatformRequest.createProvider(payload)
    }

    return (
        <Theme>
            <LoadPage load={load} />
            <Container maxWidth="sm">
                <Grid container
                    direction="column"
                    justify="center"
                    spacing={2}
                    alignItems="center">

                    <img src={logo} alt="Deixa Que Eu Procuro" height="150" className={classes.logo} />

                    {actualStep.step === 0 ?
                        <Paper elevation={3} className={classes.boxRegister}>
                            <ProviderRegisterCompanyInfo
                                provider={provider}
                                updateProvider={setProvider}
                                required={required}
                                validSsn={setSsnValid} />
                        </Paper>
                        : null}

                    {actualStep.step === 1 ?
                        <Paper elevetion={3} className={classes.boxRegister}>
                            <ProviderRegisterContact provider={provider} updateProvider={setProvider} required={required} />
                        </Paper>
                        : null}

                    {actualStep.step === 2 ?
                        <Paper elevetion={3} className={classes.boxRegister}>
                            <ProviderRegisterPassword provider={provider} updateProvider={setProvider} required={required} />
                        </Paper>
                        : null}

                    {actualStep.step === 3 ?
                        <Paper elevetion={3} className={classes.boxRegister}>
                            <Grid container direction="column"
                                justify="center"
                                spacing={2}
                                alignItems="center">
                                <Grid item>
                                    <CheckCircleOutlineIcon className={classes.iconSuccess} />
                                </Grid>
                                <Grid item>
                                    <Typography align="center" variant="h6">Cadastro realizado com sucesso! Clique no botão "ACESSAR" para utilizar a plataforma.</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                        : null}

                    <Grid container direction="row"
                        justifyContent="center"
                        alignItems="center">
                        <Grid item xs={12} lg={12} md={12}>
                            <Button
                                type="click"
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={createRegister}
                                className={classes.submit}
                            >
                                {actualStep.nextStepDescription}
                            </Button>
                        </Grid>
                        {actualStep !== 3 ?
                            <Grid item xs={12} lg={12} md={12}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    color="primary"
                                    onClick={buttonBack}
                                >
                                    Voltar
                                </Button>
                            </Grid> : null
                        }
                    </Grid>
                    <br />
                    <br />
                </Grid>
            </Container>
        </Theme>
    )


}

export default ProviderRegisterPage